import React, { useEffect, useState } from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import st from './AddClient.module.scss'
import { localisationMaster } from 'Localisation/Localisation'
import FormInput from 'components/UI/AsideModal/Form/FormInput'
import { observer } from 'mobx-react'
import InputFlagPhone from 'components/ContentBox/Global/InputPhone/InputFlagPhone/InputFlagPhone'
import FormSelectCustom from 'components/UI/AsideModal/Form/FormSelectCustom'
import SelectCustom from 'components/ContentBox/Global/Select/SelectCustom'
import useLocalization from 'hooks/useLocalization'
import SearchInput from 'components/ContentBox/Global/SearchInput/SearchInput'
import { superAxiosRequest } from 'axiosApi'

const AddClient = ({ showClientTypeToggle = false }) => {
  const {
    modalValues: modalValue,
    changeValue,
    check,
    setValid,
  } = asideModalStore

  const [isNewClient, setIsNewClient] = useState(
    showClientTypeToggle ? null : true,
  )
  const [selectedExistingClient, setSelectedExistingClient] = useState(null)
  const [managerOptions, setManagerOptions] = useState([])

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      phone_number: 'Phone number',
      name: 'Name',
      inn_iin: 'INN/IIN',
      level: 'Level',
      comment: 'Comment',
      client_type: 'Тип клиента',
      new_client: 'Новый клиент',
      existing_client: 'Существующий клиент',
      responsible: 'Ответственный',
      select_responsible: 'Выберите ответственного',
    },
  })

  useEffect(() => {
    if (isNewClient === true) {
      setValid({
        name: 'required',
        phone: 'required',
      })
    } else if (isNewClient === false) {
      setValid({
        client_id: 'required',
      })
    }
  }, [isNewClient, setValid])

  // Загрузка списка менеджеров
  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        const managerResponse = await superAxiosRequest({
          link: 'integration/employees',
          method: 'get',
          crm: true,
          params: { limit: 9999 },
        })

        if (isMounted) {
          const responsibleOptions = managerResponse.data.result.map(
            (responsible) => ({
              id: responsible.id,
              name: responsible.full_name,
            }),
          )
          setManagerOptions(responsibleOptions)
        }
      } catch (error) {
        console.error('Ошибка загрузки менеджеров:', error)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  const handleInputChange = (e) => {
    const { value } = e.target
    changeValue(value, 'name')
  }

  const handlerInnChange = (e) => {
    const { value } = e.target
    const filteredValue = value.replace(/\D/g, '')
    const limitedValue = filteredValue.slice(0, 12)
    changeValue(limitedValue, 'inn')
  }

  const handleExistingClientSelect = (value) => {
    const clientData = Array.isArray(value) ? value[0] : value
    setSelectedExistingClient(clientData?.name)
    changeValue(clientData?.id, 'client_id')
    changeValue(clientData?.name, 'client_name')
  }

  const renderClientTypeSelection = () => (
    <FormField>
      <FormLabel>{translate.client_type}:</FormLabel>
      <div className={st.btns}>
        <button
          type='button'
          className={isNewClient === true ? st.active : ''}
          onClick={() => setIsNewClient(true)}
        >
          {translate.new_client}
        </button>
        <button
          type='button'
          className={isNewClient === false ? st.active : ''}
          onClick={() => setIsNewClient(false)}
        >
          {translate.existing_client}
        </button>
      </div>
    </FormField>
  )

  if (showClientTypeToggle && isNewClient === null) {
    return renderClientTypeSelection()
  }

  return (
    <div className={st.groupForm}>
      {isNewClient ? (
        <>
          <FormField>
            <FormLabel isRequired>{translate?.name}:</FormLabel>
            <FormInput isError={check('name')}>
              <input
                type='text'
                placeholder={translate?.name}
                name='name'
                value={modalValue.name || ''}
                onChange={handleInputChange}
                maxLength={35}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel isRequired>{translate?.phone_number}:</FormLabel>
            <InputFlagPhone
              error={check('phone')}
              value={modalValue.phone || modalValue.whatsapp || ''}
              onChange={(val) => changeValue(val, 'phone')}
            />
          </FormField>

          <FormField>
            <FormLabel>{translate.responsible}:</FormLabel>
            <SelectCustom
              placeholder={translate.select_responsible}
              options={managerOptions}
              sortKey='name'
              valueID={modalValue.manager}
              onChange={(manager) => changeValue(manager.id, 'manager')}
              isSearchable
              error={check('manager')}
            />
          </FormField>

          <FormField>
            <FormLabel>{'Email:'}</FormLabel>
            <FormInput isError={check('email')}>
              <input
                type='email'
                placeholder={'Email'}
                name='email'
                value={modalValue.email || ''}
                onChange={(e) => changeValue(e.target.value, 'email')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate?.inn_iin}:</FormLabel>
            <FormInput isError={check('inn')}>
              <input
                type='text'
                placeholder={translate?.inn_iin}
                name='inn'
                value={modalValue.inn || ''}
                onChange={handlerInnChange}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{'WhatsApp:'}</FormLabel>
            <InputFlagPhone
              error={check('whatsapp')}
              value={modalValue.whatsapp || ''}
              onChange={(val) => changeValue(val, 'whatsapp')}
            />
          </FormField>

          <FormField>
            <FormLabel>{'Instagram:'}</FormLabel>
            <FormInput isError={check('company')}>
              <input
                type='text'
                placeholder={'Instagram'}
                name='instagram'
                value={modalValue.instagram || ''}
                onChange={(e) => changeValue(e.target.value, 'instagram')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{'Telegram:'}</FormLabel>
            <FormInput isError={check('telegram')}>
              <input
                type='text'
                placeholder={'Telegram'}
                name='telegram'
                value={modalValue.telegram || ''}
                onChange={(e) => changeValue(e.target.value, 'telegram')}
              />
            </FormInput>
          </FormField>

          <FormField>
            <FormLabel>{translate?.level}:</FormLabel>
            <FormSelectCustom>
              <SelectCustom
                placeholder={translate?.level}
                valueID={modalValue.level}
                error={check('level')}
              />
            </FormSelectCustom>
          </FormField>

          <FormField>
            <FormLabel>
              {localisationMaster('table-row-title-2', 'company/companies')}:
            </FormLabel>
            <textarea
              onChange={(e) => changeValue(e.target.value, 'comment')}
              value={modalValue.comment || ''}
              placeholder={translate?.comment}
              style={{
                width: '100%',
                resize: 'vertical',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ccc',
              }}
            />
          </FormField>
        </>
      ) : (
        <FormField>
          <FormLabel isRequired>Клиент:</FormLabel>
          <SearchInput
            link='integration/clients'
            placeholder='Поиск клиента по имени...'
            new_key='name'
            backFunction={handleExistingClientSelect}
            crm={true}
            initialValue={selectedExistingClient || modalValue.client_name}
            error={check('client_id')}
          />
        </FormField>
      )}
    </div>
  )
}

export default observer(AddClient)
